import pxToEm from './src/app/utils/px_to_em';
import theme from './src/app/themes';

const windowWidth = pxToEm(window.innerWidth);
const mobileMaxWidth = theme.mobileMaxWidth;

exports.shouldUpdateScroll = () => {
  if (windowWidth <= mobileMaxWidth) {
    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./gatsby-browser.js